import Vue from 'vue';
import haversine from 'haversine';

import ListoryStore from '@/store';
import { PoiState, Poi } from '@/models/poi';

export default class PoiMonitor {
    private store: ListoryStore;
    private lastPosition: Position = null;

    private eventCallback: (pos: Position) => void;

    constructor(store: ListoryStore) {
        this.store = store;
        this.eventCallback = (pos: Position) => this.onPositionUpdated(pos);
    }

    public start() {
        this.store.$on('positionUpdated', this.eventCallback);
    }

    public stop() {
        this.store.$off('positionUpdated', this.eventCallback);
    }

    public onPositionUpdated(position: Position) {
        // Ignore loading state, just check all references upon null pointers
        if (!position || !this.store || !this.store.pois || this.store.pois.length <= 0) {
            return;
        }

        // Avoid unnecessary double checks
        if (
            this.lastPosition &&
            this.lastPosition.coords &&
            position.coords.latitude === this.lastPosition.coords.latitude &&
            position.coords.longitude === this.lastPosition.coords.longitude
        ) {
            return;
        }

        for (const poi of this.store.pois) {
            const distance = haversine(poi.coordinates, position.coords, { unit: 'meter' });
            Vue.set(poi, 'distance', distance);

            const unlockDistance = this.store.settings.highAccuracyLocation ? 75 : 150;
            if (poi.state === PoiState.LOCKED && distance < unlockDistance) {
                this.onEnterPoiGeofence(poi, position);
            }
        }

        this.lastPosition = position;
    }

    private async onEnterPoiGeofence(poi: Poi, position?: Position) {
        try {
            this.store.poiJournalService.setPoiReadyToUnlock(poi, position);

            console.info('POI READY TO UNLOCK!', poi);
        } catch (error) {
            console.error('Error saving POI state! ', error);
        }
    }
}
